import { useEffect } from 'react';
import { reloadKiosk } from '../helpers/kiosk';

// Recarga programada del kiosco. Es una red de seguridad, no la cura: la regla es
// "nunca recargar mientras un cliente está usando el menú".

const CHECK_MS = 30 * 1000;
const DEFAULT_MAX_UPTIME_MS = 6 * 60 * 60 * 1000; // 6 h de uso continuo
const DEFAULT_IDLE_MS = 90 * 1000;                // 90 s sin que nadie toque la pantalla
const DEFAULT_NIGHTLY_HOUR = 4;                   // ventana de madrugada (hora local)
const MIN_UPTIME_MS = 60 * 60 * 1000;             // nunca recargar recién arrancado

const TOUCH_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'wheel'];

export const useKioskReload = ({
  maxUptimeMs = DEFAULT_MAX_UPTIME_MS,
  idleMs = DEFAULT_IDLE_MS,
  nightlyHour = DEFAULT_NIGHTLY_HOUR,
} = {}) => {
  useEffect(() => {
    const startedAt = Date.now();
    let lastTouch = Date.now();

    const touch = () => { lastTouch = Date.now(); };
    TOUCH_EVENTS.forEach((event) =>
      window.addEventListener(event, touch, { passive: true, capture: true })
    );

    const timer = setInterval(() => {
      const now = Date.now();
      const uptime = now - startedAt;
      const idle = now - lastTouch;

      if (uptime < MIN_UPTIME_MS) return;
      if (idle < idleMs) return;                            // hay alguien usándolo
      if (document.visibilityState !== 'visible') return;   // app en segundo plano

      if (uptime >= maxUptimeMs) {
        reloadKiosk(`${Math.round(uptime / 3600000)} h de uptime`);
        return;
      }

      // La ventana de madrugada solo aplica si ya lleva más de una hora encendido, así no
      // se repite la recarga cada 30 s durante toda esa hora.
      if (new Date().getHours() === nightlyHour) {
        reloadKiosk('ventana de madrugada');
      }
    }, CHECK_MS);

    return () => {
      clearInterval(timer);
      TOUCH_EVENTS.forEach((event) =>
        window.removeEventListener(event, touch, { capture: true })
      );
    };
  }, [maxUptimeMs, idleMs, nightlyHour]);
};
